// SPDX-License-Identifier: BUSL-1.1

/**
 * TenantSettingsPage — cloud provider connection page.
 *
 * Path: /tenant-settings
 * Auth: sessionAuth via RequireAuth in app.tsx
 *
 * Allows tenant to:
 * - Select a cloud provider (Hetzner first, others coming)
 * - Enter a cloud API token (encrypted before storage)
 * - Update or clear credentials
 */

import { Card } from '@/components/ui/card';
import { TenantSettingsForm } from '@/components/tenant-settings-form';

export function TenantSettingsPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-100">Cloud Provider</h1>
        <p className="mt-1 text-sm text-neutral-400">
          Connect your Hetzner Cloud account to enable BYOH runner provisioning.
          Your API token is AES-256-GCM encrypted before storage — never logged in plaintext.
        </p>
      </div>

      <Card className="max-w-xl p-6">
        <TenantSettingsForm />
      </Card>

      <div className="max-w-xl rounded border border-blue-900/40 bg-blue-950/20 p-4">
        <h2 className="mb-2 text-sm font-semibold text-blue-400">How it works</h2>
        <ol className="flex list-inside list-decimal flex-col gap-1.5 text-xs text-neutral-400">
          <li>Enter your Hetzner API token above</li>
          <li>Add <code className="rounded bg-neutral-900 px-1.5 py-0.5 font-mono text-neutral-300">runs-on: [self-hosted, hetzner-runner]</code> to your workflow YAML</li>
          <li>Push a commit — Builder-CEO provisions a runner VM in your Hetzner account</li>
          <li>The runner picks up your job from GitHub Actions, then is cleaned up</li>
        </ol>
      </div>
    </div>
  );
}